import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { useProfile } from "../../../../Components/Hooks/UserHooks";
import { theme } from "../theme";

const ContractDetailHeader = ({ contract, onEditClick }) => {
  const { isAdmin, isEditor } = useProfile();
  const canEdit = isAdmin || isEditor;

  const clientName = contract?.client
    ? `${contract.client.name || ""} ${contract.client.surname || ""}`.trim()
    : null;

  const notaryName = contract?.notary ? `${contract.notary || ""}`.trim() : null;

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          fontSize: 12.5,
          color: theme.textMuted,
          marginBottom: 18,
        }}
      >
        <Link to="/financial/contracts" style={{ color: theme.textMuted }}>
          Contracts
        </Link>
        <span>/</span>
        <span style={{ color: theme.text }}>Contract #{contract?.pvc_number}</span>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: 20,
          marginBottom: 22,
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: "1 1 320px", minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <h1 style={{ margin: 0, fontSize: 27, fontWeight: 650, letterSpacing: "-0.5px" }}>
              Contract #{contract?.pvc_number}
            </h1>
            <span
              style={{
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: "0.5px",
                textTransform: "uppercase",
                padding: "4px 9px",
                borderRadius: 6,
                background: contract?.active ? theme.successBg : theme.neutralBadgeBg,
                color: contract?.active ? theme.success : theme.textMuted,
              }}
            >
              {contract?.active ? "Active" : "Inactive"}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              gap: 16,
              flexWrap: "wrap",
              marginTop: 8,
              fontSize: 13.5,
              color: theme.textSecondary,
              alignItems: "center",
            }}
          >
            <span>PVC–{contract?.pvc_number}</span>
            <span style={{ color: theme.border }}>·</span>
            <span>Signed: {contract?.pvc_date ? moment(contract.pvc_date).format("D MMM YYYY") : "—"}</span>
            {notaryName && (
              <>
                <span style={{ color: theme.border }}>·</span>
                <span>
                  Notary: {" "}
                  <a style={{ color: theme.accent }}>
                    {notaryName}
                  </a>
                </span>
              </>
            )}
            {clientName && (
              <>
                <span style={{ color: theme.border }}>·</span>
                <span>
                  Buyer: {" "}
                  <a href={`/client-details/${contract.client.id}`} style={{ color: theme.accent }}>
                    {clientName}
                  </a>
                </span>
              </>
            )}
            <span style={{ color: theme.border }}>·</span>
            <span>
              Currency: {contract?.currency}
              {contract?.currency === "RON" && contract?.exchange_rate != null && (
                <span style={{ color: theme.textMuted }}> (1 EUR = {Number(contract.exchange_rate).toFixed(4)} RON)</span>
              )}
            </span>
          </div>
        </div>
        <div style={{ display: "flex", gap: 9, alignItems: "center" }}>
          <button
            type="button"
            disabled
            title="PDF export isn't available for contracts yet"
            style={{
              font: "inherit",
              fontSize: 13,
              fontWeight: 600,
              padding: "9px 15px",
              borderRadius: 9,
              border: `1px solid ${theme.border}`,
              background: theme.surface,
              color: theme.text,
              cursor: "not-allowed",
              opacity: 0.6,
            }}
          >
            Download PDF
          </button>
          {canEdit && (
            <button
              type="button"
              onClick={onEditClick}
              style={{
                font: "inherit",
                fontSize: 13,
                fontWeight: 600,
                padding: "9px 15px",
                borderRadius: 9,
                border: "1px solid transparent",
                background: theme.accent,
                color: "#fff",
                cursor: "pointer",
              }}
            >
              Edit contract
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default ContractDetailHeader;
